export default {
    COOKIE: 6,
    LOCATION_DATA: 5,
    KVKK: 1,
    USER_AGREEMENT: 2,
    CONFIDENTIALITY: 4,
    PAYMENT: 4,
}
